<template>
  <section id="who">
    <v-spacer size="100px"></v-spacer>
    <div class="container">
      <h2>Do you know about Neopets?</h2>
      <v-spacer size="100px"></v-spacer>
      <div class="bs_row">
        <div class="bs_one bs_margin30">
          <figure>
            <img src="/images/mari.png" alt="photo of mari and some muppets">
            <figcaption>meep meep</figcaption>
          </figure>
        </div>
        <div class="bs_two left-margin right-margin">
          <div>
            <p style="font-weight: 600;">One day in 2002, 12-year-old Mari logged into her Neopets account (username: AnimeMayhem112, don't judge me I was TWELVE, geez). She looked at her menagerie of digital pets. She looked at the copy of "HTML for Dummies" on the desk before her.</p>
            <v-spacer/>
            <p style="font-weight: 600;">"I know what I must do" she said. And thus her first piece of code was born: a homepage for her pet Kougra.</p>
            <v-spacer/>
            <p>Ever since that fateful day, I made web development a hobby. I made websites for ALL of my friends (and fan pages for all of my favorite rock stars and fictional characters) up until I got my degree in Computer Science at NYU, with a minor in Web Programming and Applications. Unfortunately NYU didn't offer a major in Neopet Homepage Design specifically.</p>
            <v-spacer/>
            <p>In my career, I've worked on a lot of awesome projects. I've created scraper bots in Python to collect data for an internship from across the web and twitter bots that measured people's average sentiment about a subject using Natural Language Processing. I've worked with enormous companies like NBC, IBM, Pfizer, Merck, and Intel. I've paired up with start-ups, such as ion Learning, Jozii, and Mojo Motors. I've even created fun sites for independent musicians and portfolios for artists. Did I tell you about the robots I made? I even made robots! And I'd love to make your project next!</p>
            <v-spacer/>
            <p class="bs_margin40">When not working, you can usually find me running a few miles with my dog, reading while on a long walk (I'm thinking of pitching read-walking as the next big olympic sport), or drawing comics! I hope that you and I can work together in the future! :)</p>
            <v-spacer/>
            <div class="bs_centeredOnMobile">
              <a class="cta" target="_blank" rel="noreferrer"
                 href="https://www.linkedin.com/in/mari-garibov/">view my resume on linkedin</a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <v-spacer size="100px"></v-spacer>
  </section>
</template>

<script>
  import VSpacer from './VSpacer'

  export default {
    name: 'What',
    components: {
      VSpacer
    }
  }
</script>
